module.exports = __webpack_public_path__ + "media/images/samples/home/news/f1-f33c8fe0a34d1a066ade3f7bc066d570.png";